<template>
  <v-card class="fade-in one standardCardFile ml-1 mr-1 mt-2" flat >
    <v-layout column>
   <v-layout style="height:200;" column>
    <span class="fade-in three" style="font-size:30px; text-align:center; font-weight:700;">{{dataValue}}</span>
       <v-layout column class="pa-2" style="border-top: 1px solid #E8EAED; background-color:white; width:100%; bottom:0;" row>
      <span class="mainTitle truncate">{{ labelValue }}</span>
      <span class="subtitle truncate">{{ partnerValue }}</span>
    </v-layout>
   </v-layout>
    </v-layout>
  </v-card>
</template>

<style lang="scss" scoped>
$font: sans-serif;
$color: #1565c0;
$gender: #666;
$birthdate: #999;
$addr: #1565c0;
$background-gray: rgb(206, 206, 206);

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.unemphasized {
  opacity: .3;;
}

.fadeText {
  position: relative;
  height: 4.8em; /* exactly four lines */
  text-align: justify;
  color: #666;
}
.fadeText:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 70%;
  height: 1.6em;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
}


.standardCardFile {
  height: auto !important;
  border: 1px solid #E8EAED;
  border-radius:6px;
  overflow:hidden;
    background-color: white;
    height: 1.2em;
    background-color:#f5f5f5;
    cursor: pointer;

  .mainTitle {
  font-size: 14px;
  line-height: 18px;
  margin-bottom:1px;
  text-align: left;
  font-weight: 700;
  color: #343434;
  background-color:transparent;
}

.subtitle {
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  font-weight: 500;
  color: #343434;
  background-color:transparent;
}

.dateTitle {
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  font-weight: 500;
  color: #343434;
  background-color:transparent;
}

.subtitleSmall {
  font-size: 10px;
  line-height: 12px;
  text-align: left;
  font-weight: 500;
  color: #343434;
  background-color:transparent;
}

}

.standardCardFile:hover {
    background-color: white;
}

</style>
<script>

export default {
  name: 'FileCard',
  props: {
    dataValue: {
      type: Number,
      default: null
    },
    labelValue: {
      type: String,
      default: ''
    },
    partnerValue: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/DataCard.vue